export const LEVELS = {
  LOCATION: 'location',
  PARTNER: 'partner',
  GROUP: 'group',
  REGION: 'region',
};

export const ACTIONS = {
  CANCEL_REFUND_DEPENDENT: 'cancelRefundDependent',
  DELETE_DEPENDENT: 'deleteDependent',
};

export const PLAN_FREQUENCIES = {
  annually: 'Annually',
  halfyearly: 'Every 6 Months',
  quarterly: 'Every 3 Months',
  monthly: 'Monthly',
  // weekly: "Weekly",
};

export const EXT_PLAN_FREQUENCIES = {
  annually: 'Annually',
  halfyearly: 'Every 6 Months',
  four_months: 'Every 4 Months',
  quarterly: 'Every 3 Months',
  monthly: 'Monthly',
  // weekly: "Weekly",
  unlimited: 'Unlimited',
};

export const FREQUENCY_MAPPER = {
  annually: 0,
  halfyearly: 6,
  four_months: 4,
  quarterly: 3,
  monthly: 1,
  weekly: 0,
};

export const FEE_SCHEDULE_MAPPER = {
  ucr_fees_schedule: 'UCR Fee Schedule',
};

export const SUBSCRIPTION_TYPE = {
  CUSTOMER: {
    name: 'Subscriber',
    value: 'Customer',
  },
  EMPLOYEE: {
    name: 'Employee',
    value: 'Employee',
  },
};

export const CAROUSEL_RESPONSIVE = {
  extraSuperLargeDesktop: {
    breakpoint: { max: 4000, min: 1800 },
    items: 4,
  },
  superLargeDesktop: {
    breakpoint: { max: 1800, min: 1400 },
    items: 3,
  },
  largeDesktop: {
    breakpoint: { max: 1400, min: 1200 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 1200, min: 992 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 992, min: 768 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
  },
};

export const BUTTON_TEXT = {
  login: 'Log In',
  validating: 'Validating Details...',
};

// Default Stripe Charges
export const REACT_APP_STRIPE_CHARGE_PERCENT = 2.9;
export const REACT_APP_STRIPE_CHARGE_FIXED_CENTS = 31;

// Credit Card Dynamic Charges
export const REACT_APP_CREDIT_CHARGE_PERCENT = 3;
export const REACT_APP_CREDIT_CHARGE_FIXED_CENTS = 0;

// Debit Card Dynamic Charges
export const REACT_APP_DEBIT_CHARGE_PERCENT = 0;
export const REACT_APP_DEBIT_CHARGE_FIXED_CENTS = 0;

// Affirm Dynamic Charges
export const REACT_APP_AFFIRM_PERCENT = 5;
export const REACT_APP_AFFIRM_FIXED_CENTS = 30;

// Zipcode pattern (US format)
export const ZIPCODE_PATTERN = /^\d{5}(-\d{4})?$/;
// Postcode pattern (UK format)
export const POSTCODE_PATTERN = /^[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}$/i;
export const EMAIL_PATTERN =
  /^([A-Za-z0-9+_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,})$/;

// Terminal Retry count :
export const TERMINAL_RETRY_COUNT = 120;

// Session inactivity logout window — env-driven (non-prod: 12h, prod: 8h).
// Falls back to the non-prod default when REACT_APP_SESSION_DURATION_HOURS is unset.
export const SESSION_DURATION_HOURS =
  Number(process.env.REACT_APP_SESSION_DURATION_HOURS) || 12;
export const SESSION_DURATION_MS = SESSION_DURATION_HOURS * 60 * 60 * 1000;
